import { render, staticRenderFns } from "./Advise.vue?vue&type=template&id=830a70ca"
import script from "./Advise.vue?vue&type=script&lang=js"
export * from "./Advise.vue?vue&type=script&lang=js"
import style0 from "./Advise.vue?vue&type=style&index=0&id=830a70ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports